'use strict';

var resolver = require('./template-resolver');

function parse(templates, bootstrap, deps) {
	var _ = deps.underscore;
	var customTemplates = _.extend({}, templates);

	for (var key in customTemplates) {
		if (customTemplates[key] !== '') {
			customTemplates[key] = resolver.resolve(customTemplates[key], bootstrap, deps);
		}
	}
	return customTemplates;
}

module.exports = parse;




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/template-parser.js
// module id = 2
// module chunks = 0